<template>
    <div>
        <div class="form-row" v-for="(medication, key) in localValue" :key="key">
            <el-input v-model="localValue[key].name" @input="handleMedicationNameInput(key)" class="col-12 col-lg-5" type="text" :name="`${$t(`form-elements.${name}`)}_${_uid}_${key}`" :as="$t(`form-elements.${name}`)" :label="$t(`form-elements.${name}`)" :hasLabel="key === 0" :placeholder="$t(`form-elements.${name}_placeholder`)" :rule="(key+1 !== localValue.length) || key === 0 ? rule : null"></el-input>
        </div>
    </div>
</template>

<script>
import { ElInput } from '@/components/forms'

export default {
    inject: ['$validator'],
    components: { ElInput },
    props: {
        value: {
            required: true
        },
        type: {
            required: true
        },
        rule: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: 'medication_name',
        }
    },

    data() {
        return {
            localValue: this.value
        }
    },

    methods: {
        handleMedicationNameInput(key) {

            if (this.localValue[key].name.length) {
                if (!this.localValue[key + 1]) this.localValue[key + 1] = { name: '', medication_type_id: 1 }
            } else if (key === this.localValue.length - 2) {
                this.localValue.splice(-1, 1)
            }
            this.$forceUpdate()
            this.handleChange
        },
        handleChange() {
            this.localValue.medication_type_id = this.type
            this.$emit('input', this.localValue)
        }
    },

    watch: {
        value() {
            this.localValue = this.value;
        },
    },
};
</script>
